<template>
  <div class="container">
  <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>  
    <div class="row">
      <div class="col-md-12">
        <div class="widget-wrap">
          <div class="widget-container margin-top-0">
            <div class="widget-content">
              <div class="row">
                <div class="col-md-12">
                  <form class="j-forms" novalidate>
                    <div class="form-content">
                      <div class="w-section-header">
                        <h3>Password reset</h3>
                      </div>
                      <div v-if="recoverErr" class="row">
                        <div class="col-sm-6 col-sm-offset-3">
                          <div class="error-message">
                            <p>{{ recoverErr }}</p>
                          </div>
                        </div>
                      </div> 

                      <div v-if="success" class="row">
                        <div class="col-sm-6 col-sm-offset-3 unit">
                          <div class="success-message">
                            <i class="fa fa-check"></i>
                            <strong>Mail sent successfully!</strong>
                          </div>
                        </div>                        
                      </div>
                      <div v-if="success" class="row">
                        <a href="/login"><button type="button" class="btn btn-primary">OK</button></a> 
                      </div>                     
                      <div v-if="!success" class="row">
                        <div class="col-sm-6 col-sm-offset-3 unit">
                            <div class="input">
                              <label class="icon-left" for="email">
                                <i class="fa fa-envelope-o"></i>
                              </label>
                              <input v-model="email" v-validate="'required|email'" class="form-control" type="email" placeholder="Email" name="email" id="email" autofocus="autofocus">
                              <span v-show="errors.has('email')" class="error-view">{{ errors.first('email') }}</span>
                            </div>
                          </div>
                      </div>
                      <div v-if="!success" class="row">
                        <button type="button" class="btn btn-primary" @click="recoverPass()">Send-me an email</button>
                        <span class="hint">
                          <br/>
                          <router-link to="login" class="link">Login</router-link>
                          <span> or </span>
                          <router-link to="register" class="link">Register</router-link>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import auth from '../auth'
  export default {
    data () {
      return {
        recoverErr: '',
        email: '',
        success: false,
        loading: false
      }
    },
    methods:{
      recoverPass() {
        auth.recoverPass(this, this.email)
      }      
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Recover.vue